import React from 'react';
import './Home.css';

function Home() {
  return (
    <div className="home-container">
      {/* Left Section: Text */}
      <div className="text-container">
        <h1>Hi, <br /> I'm <span className="highlight">Arya</span></h1>
        <p className="subtitle">CS at UVic</p>
        <p className="description">Backend Developer | Exploring AI/ML</p>
        <p className="description">Currently learning to build and deploy ML Apps</p>
        
        {/* Buttons */}
        <div className="button-container">
          <a href="https://house-price-predictor-for-lh.streamlit.app/" target="_blank" rel="noopener noreferrer" className="btn">Latest ML App</a>
          <a href="/Arya_Resume.pdf" download className="btn">Download Resume</a>
          <a href="about" className="btn">My Story</a>
        </div>
      </div>

      {/* Right Section: Avatar */}
      <div className="avatar-container">
        <img src="/avatar.png" alt="Arya" className="profile-pic" />
      </div>
    </div>
  );
}

export default Home;
